import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../material.module';
import { TextFieldModule } from '@angular/cdk/text-field';

import { ChatContainerComponent } from './chat-container/chat-container.component';
import { ChatMessageComponent } from './chat-message/chat-message.component';
import { ChatInputComponent } from './chat-input/chat-input.component';
import { TypingIndicatorComponent } from '../shared/typing-indicator/typing-indicator.component';
import { LinkifyPipe } from '../pipes/linkify.pipe';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    TextFieldModule,
    ChatContainerComponent,
    ChatMessageComponent,
    ChatInputComponent,
    TypingIndicatorComponent,
    LinkifyPipe
  ],
  exports: [
    ChatContainerComponent
  ]
})
export class ChatModule { }
